export default {"src":"/_next/static/media/easycapital_logo.775e9ac5.svg","height":55,"width":324};